import { ChartData } from "../Editor/Displays/Chart";
import { renderBarChart } from "./Charts/BarChart";
import { renderLineChart } from "./Charts/LineChart";
import { renderPieChart } from "./Charts/PieChart";

export function renderChartForEditor(chartData){
    if (Apex._chartInstances !== undefined && Apex._chartInstances.length > 0){
        
        ApexCharts.exec("display-chart", "updateOptions", chartData, true, true).then(() => {
            
        })
    } else {
        renderChart(chartData, '#display-chart', 'display-chart');
    }
}

export function renderChart(chartData, selector="#display-chart", chartId='display-chart'){
    chartData.chart.id = chartId;
    const chart = new ApexCharts(document.querySelector(selector), chartData);
    chart.render();    
}

export function renderDisplayChart(chartData, object:HTMLElement){
    const chart = new ApexCharts(object, chartData);
    chart.render();    
}

export function transformDataToChartData(data:ChartData){
    let chartData = standardChartData(data);
    switch(data.chartType){
        case "pie":
            chartData = renderPieChart(data, chartData);
        break;
        case "bar":
            chartData = renderBarChart(data, chartData);
        break;
        case "line":
            chartData = renderLineChart(data, chartData);
        break;
    }
    return chartData;
}

function standardChartData(data:ChartData){
    const chartData = {
        chart: {
            height: 350,
            type: data.chartType,
            zoom: {
                enabled: false,
            }
        },
        xaxis: {
            categories: data.labels,
        },
        series: [{
            name: data.names[0],
            data: data.values[0]
        }],
        plotOptions: {
            bar: {
                columnWidth: "50%",
                distributed: true,
            }
        }
    }
    return chartData;
}